import React from "react";
import { Dialog, Divider } from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";

import SoftBox from "./components/SoftBox";
import SoftTypography from "./components/SoftTypography";
import SoftButton from "./components/SoftButton";
import GMBLogo from "./img/gmb-installer.png";
import ShareGif from "./img/ca-share-link.gif";
import ArrowGif from "./img/ca-arrow.gif";

import useIosInstallPrompt from "./hooks/useIosInstallPrompt";
import useWebInstallPrompt from "./hooks/useWebInstallPrompt";

const AppInstaller = () => {
  const [iosInstallPrompt, handleIOSInstallDeclined] = useIosInstallPrompt();
  const [webInstallPrompt, handleWebInstallDeclined, handleWebInstallAccepted] =
    useWebInstallPrompt();
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  console.log("isMobile", isMobile);

  if ((!iosInstallPrompt && !webInstallPrompt) || !isMobile) {
    return null;
  }

  return (
    <div className="app-installer">
      <Dialog
        open={true}
        sx={{
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "400px",
            // glass
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)",
            boxShadow:
              "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
            borderRadius: "24px",
            border: "1px solid rgba(255,255,255,0.6)",
            backdropFilter: "blur(18px) saturate(160%)",
          },
        }}
      >
        <SoftBox sx={{ padding: { mini: "1rem", md: "1.5rem" } }}>
          <SoftTypography
            component="h3"
            sx={{ color: "#0F172A", fontSize: "20px !important" }}
          >
            Add to Home Screen
          </SoftTypography>
          <Divider
            sx={{
              margin: 0,
              backgroundImage:
                "linear-gradient(to right, rgba(15,23,42,0.10), rgba(15,23,42,0.10), rgba(15,23,42,0.10)) !important",
            }}
          />
          {webInstallPrompt && (
            <>
              <SoftBox display="flex" flexDirection="column" mb="20px">
                <SoftTypography
                  component="h3"
                  sx={{
                    color: "#0F172A",
                    fontSize: "20px !important",
                    marginTop: "20px",
                  }}
                >
                  GameMybiz
                </SoftTypography>
                <SoftTypography
                  component="p"
                  sx={{
                    color: "#475467",
                    fontSize: "16px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    marginBottom: "20px",
                  }}
                >
                  Install the app on your device to easily access it anytime.
                </SoftTypography>
                <SoftBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    background: "rgba(15,23,42,0.03)",
                    border: "1px dashed rgba(15,23,42,0.10)",
                    borderRadius: "12px",
                  }}
                >
                  <img src={GMBLogo} alt="" className="w-[100%] max-w-[50px]" />
                  <img
                    src={ArrowGif}
                    alt=""
                    className="w-[100%] max-w-[50px]"
                  />
                  <img
                    src={ShareGif}
                    alt=""
                    className="w-[100%] max-w-[50px]"
                  />
                </SoftBox>
              </SoftBox>
              <Divider
                sx={{
                  margin: 0,
                  backgroundImage:
                    "linear-gradient(to right, rgba(15,23,42,0.10), rgba(15,23,42,0.10), rgba(15,23,42,0.10)) !important",
                }}
              />
              <SoftBox mt="20px" display="flex">
                <SoftButton
                  fullWidth
                  variant="contained"
                  sx={{ marginRight: "20px" }}
                  onClick={handleWebInstallDeclined}
                >
                  Not now
                </SoftButton>
                <SoftButton
                  fullWidth
                  variant="contained"
                  sx={{
                    background:
                      "linear-gradient(120deg, #6675D3 0%, #141727 100%)",
                    color: "#FFFFFF",
                  }}
                  onClick={handleWebInstallAccepted}
                >
                  Install
                </SoftButton>
              </SoftBox>
            </>
          )}

          {iosInstallPrompt && (
            <SoftBox display="flex" flexDirection="column" mt="20px">
              <SoftTypography
                component="h3"
                sx={{
                  color: "#0F172A",
                  fontSize: "20px !important",
                }}
              >
                GameMybiz
              </SoftTypography>
              <SoftTypography
                component="p"
                sx={{
                  color: "#475467",
                  fontSize: "16px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  marginBottom: "20px",
                }}
              >
                Install the app on your device to easily access it anytime.
                <br />
                Tap <IosShareIcon /> then "Add to Home Screen"
              </SoftTypography>
              <SoftBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                  background: "rgba(15,23,42,0.03)",
                  border: "1px dashed rgba(15,23,42,0.10)",
                  borderRadius: "12px",
                }}
              >
                <img src={GMBLogo} alt="" className="w-[100%] max-w-[50px]" />
                <img src={ArrowGif} alt="" className="w-[100%] max-w-[50px]" />
                <img src={ShareGif} alt="" className="w-[100%] max-w-[50px]" />
              </SoftBox>
              <Divider
                sx={{
                  margin: 0,
                  backgroundImage:
                    "linear-gradient(to right, rgba(15,23,42,0.10), rgba(15,23,42,0.10), rgba(15,23,42,0.10)) !important",
                }}
              />
              <SoftBox mt="20px" display="flex">
                <SoftButton
                  fullWidth
                  variant="contained"
                  sx={{ marginRight: "20px" }}
                  onClick={handleIOSInstallDeclined}
                >
                  Not now
                </SoftButton>
              </SoftBox>
            </SoftBox>
          )}
        </SoftBox>
      </Dialog>
    </div>
  );
};

export default AppInstaller;
